type ChipSize = 'sm' | 'md' | 'lg';

const paddingBySize: Record<ChipSize, string> = {
  sm: '1px 8px',
  md: '2px 10px',
  lg: '6px 14px',
};

const fontBySize: Record<ChipSize, string> = {
  sm: '11px',
  md: '12px',
  lg: '14px',
};

export { fontBySize, paddingBySize };
export type { ChipSize };
